import { action } from '@sas/nova-commons/action';
import { createReducer } from '../utils/action/createReducer';
const AT = {
    SetReportObjectName: 'bird/SetReportObjectName',
    SetViewSetReport: 'bird/SetViewSetReport',
    FocusVisual: 'bird/FocusVisual',
    SetFocusedVisual: 'bird/SetFocusedVisual',
    SetSelectedVisual: 'bird/SetSelectedVisual',
    SetMaximizeVisual: 'bird/SetMaximizeVisual',
    ToggleMaximizeVisual: 'bird/ToggleMaximizeVisual',
    SetMaximizeAutofocusVisualId: 'bird/SetMaximizeAutofocusVisualId',
    SetReportTheme: 'bird/SetReportTheme',
    SetReportBackgroundColor: 'bird/SetReportBackgroundColor',
    SetPageTabStyle: 'bird/SetPageTabStyle',
    SetReportLabel: 'bird/SetReportLabel',
    SetRestrictViewportGestures: 'bird/SetRestrictViewportGestures',
};
export const BirdState = {
    actions: {
        setReportObjectName: (name) => action(AT.SetReportObjectName, name),
        setViewSetReport: (viewSetReport) => action(AT.SetViewSetReport, viewSetReport),
        focusVisual: (id) => action(AT.FocusVisual, id),
        setFocusedVisual: (id) => action(AT.SetFocusedVisual, id),
        setSelectedVisual: (id) => action(AT.SetSelectedVisual, id),
        setMaximizedVisual: (id) => action(AT.SetMaximizeVisual, id),
        toggleMaximizedVisual: (id) => action(AT.ToggleMaximizeVisual, id),
        setMaximizeAutofocusVisualId: (id) => action(AT.SetMaximizeAutofocusVisualId, id),
        setReportTheme: (themeName) => action(AT.SetReportTheme, themeName),
        setReportBackgroundColor: (color) => action(AT.SetReportBackgroundColor, color),
        setPageTabStyle: (style) => action(AT.SetPageTabStyle, style),
        setReportLabel: (label) => action(AT.SetReportLabel, label),
        setRestrictViewportGestures: (required) => action(AT.SetRestrictViewportGestures, required),
    },
    actionTypes: AT,
    reducer: createReducer({
        potentialFocusedVisual: null,
        focusedVisual: null,
        selectedVisual: null,
        maximizedVisual: null,
        reportTheme: null,
        reportBackgroundColor: null,
        pageTabStyle: null,
        reportLabel: '',
        maximizeAutofocusVisualId: null,
        restrictViewportGestures: undefined,
    }, {
        [AT.SetReportObjectName]: (state, action) => {
            return Object.assign(Object.assign({}, state), { name: action.payload });
        },
        [AT.SetViewSetReport]: (state, action) => {
            return Object.assign(Object.assign({}, state), { viewSetReport: action.payload });
        },
        [AT.FocusVisual]: (state, action) => {
            return Object.assign(Object.assign({}, state), { potentialFocusedVisual: action.payload });
        },
        [AT.SetFocusedVisual]: (state, action) => {
            return Object.assign(Object.assign({}, state), { focusedVisual: action.payload });
        },
        [AT.SetSelectedVisual]: (state, action) => {
            return Object.assign(Object.assign({}, state), { selectedVisual: action.payload });
        },
        [AT.SetMaximizeVisual]: (state, action) => {
            return Object.assign(Object.assign({}, state), { maximizedVisual: action.payload, maximizeAutofocusVisualId: action.payload });
        },
        [AT.ToggleMaximizeVisual]: (state, action) => {
            return Object.assign(Object.assign({}, state), { maximizedVisual: state.maximizedVisual === action.payload ? null : action.payload, maximizeAutofocusVisualId: action.payload });
        },
        [AT.SetMaximizeAutofocusVisualId]: (state, action) => {
            return Object.assign(Object.assign({}, state), { maximizeAutofocusVisualId: action.payload });
        },
        [AT.SetReportTheme]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportTheme: action.payload });
        },
        [AT.SetReportBackgroundColor]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportBackgroundColor: action.payload });
        },
        [AT.SetPageTabStyle]: (state, action) => {
            return Object.assign(Object.assign({}, state), { pageTabStyle: action.payload });
        },
        [AT.SetReportLabel]: (state, action) => {
            return Object.assign(Object.assign({}, state), { reportLabel: action.payload });
        },
        [AT.SetRestrictViewportGestures]: (state, action) => {
            return Object.assign(Object.assign({}, state), { restrictViewportGestures: action.payload });
        },
    }),
};
